import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "default-template" }
const _hoisted_2 = { class: "tw-flex tw-w-full tw-mb-[3rem]" }

import { computed } from "vue";

import Header from "@/components/templates/header/Header.vue";
import Navigation from "@/components/templates/shared/Navigation.vue";

import { hideUserName } from "@/components/templates/helpers/HideUserName";


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultTemplate',
  setup(__props) {

const showUserName = computed((): boolean => {
  return !hideUserName.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, { showUserName: _unref(showUserName) }, null, 8, ["showUserName"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Navigation),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})